<p *ngIf="displayFakeDate">Simulerat dagens datum {{sxFakeDate }}</p>
<div class="sx-disruption__pane" *ngIf="!isLoading">
   <!-- Leveransstörning -->
   <app-system-message *ngIf="displayDeliveryDisruptions" 
    [isVisible]="true" 
    [isDismissable]="false" 
    [severity]="2" 
    [icon]="'#sx-varning'"
    [type]="3">
    <a *ngIf="isStartPageView" href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
      {{deliveryDisruptions}}
      {{ (deliveryDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
    </a>
    <ng-container *ngIf="!restoreTimeFormated">
      {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-delivery-disruption' | translate) + '. ' + ('disruptions.restore_information_label_short_not_set' | translate)) : ('disruptions.delivery_disruption_message' | translate) }} 
    </ng-container>
    
    <ng-container *ngIf="restoreTimeFormated">
      {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-delivery-disruption' | translate)  + '. ' + ('disruptions.restore_time' | translate) + restoreTimeFormated) : ('disruptions.delivery_disruption_message' | translate) }} 
    </ng-container>
   </app-system-message>

  <!-- Planerat avbrott -->
  <app-system-message *ngIf="displayPlanneDisruptions" 
    [isVisible]="true" 
    [isDismissable]="false" 
    [severity]="2" 
    [icon]="'#sx-varning'"
    [type]="3">
    <a *ngIf="isStartPageView" href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
      {{plannedDisruptions}}
      {{ (plannedDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
    </a>
    <ng-container *ngIf="!restoreTimeFormated">
      {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-planned-disruption' | translate) + '. ' + ('disruptions.restore_information_label_short_not_set' | translate)) : ('disruptions.planned_message' | translate) }} 
    </ng-container>
    
    <ng-container *ngIf="restoreTimeFormated">
      {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-planned-disruption' | translate)  + '. ' + ('disruptions.restore_time' | translate) + restoreTimeFormated) : ('disruptions.planned_message' | translate) }} 
    </ng-container>
  </app-system-message>

  <!-- Driftstörningar -->
  <app-system-message *ngIf="displayUnplannedDisruptions" 
    [isVisible]="true" 
    [isDismissable]="false" 
    [severity]="3" 
    [icon]="'#sx-blocked'"
    [type]="3">
    <a *ngIf="isStartPageView" href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
      {{unPlannedDisruptions}}
      {{ (unPlannedDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
    </a>
    
    <ng-container *ngIf="!restoreTimeFormated">
      {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-unplanned-disruption' | translate)  + '. ' + ('disruptions.restore_information_label_short_not_set' | translate)) : ('disruptions.unplanned_message' | translate) }}       
    </ng-container>

    <ng-container *ngIf="restoreTimeFormated">
      {{ selectedMeteringPointDisruption ? (('disruptions.ongoing-unplanned-disruption' | translate)  + '. ' + ('disruptions.restore_time' | translate) + restoreTimeFormated) : ('disruptions.unplanned_message' | translate) }}       
    </ng-container>
  </app-system-message>

  <!-- Åtgärdade -->
  <app-system-message *ngIf="displayRestoredDisruptions" 
    [isVisible]="true" 
    [isDismissable]="false" 
    [severity]="1" 
    [icon]="'#sx-info'"
    [type]="3">
    <a *ngIf="isStartPageView" href="#" [routerLink]="['/secure/meteringpoints/disruptions']" class="sx-disruption__link">
      {{restoredDisruptions}}
      {{ (restoredDisruptions === 1 ? 'disruptions.link_message_single' : 'disruptions.link_message') | translate}}
    </a>

    <ng-container *ngIf="isStartPageView">
      {{ 'disruptions.restored_message' | translate }} 
    </ng-container>

    <ng-container *ngIf="selectedMeteringPointRestoredDisruption && selectedMeteringPointRestoredDisruption.disturbanceType === disturbanceTypeEnum.Planned">
      {{ ('disruptions.restored_planned_message_single' | translate) + (selectedMeteringPointRestoredDisruption.startTime | date: 'HH:mm, d MMMM yyyy') }} 
    </ng-container>

    <ng-container *ngIf="selectedMeteringPointRestoredDisruption && selectedMeteringPointRestoredDisruption.disturbanceType === disturbanceTypeEnum.Delivery">
      {{ ('disruptions.restored_delivery_message_single' | translate) + (selectedMeteringPointRestoredDisruption.startTime | date: 'HH:mm, d MMMM yyyy') }} 
    </ng-container>

    <ng-container *ngIf="selectedMeteringPointRestoredDisruption && (selectedMeteringPointRestoredDisruption.disturbanceType === disturbanceTypeEnum.Unplanned || selectedMeteringPointRestoredDisruption.disturbanceType === disturbanceTypeEnum.Unknown)">
      {{ ('disruptions.restored_unplanned_message_single' | translate) + (selectedMeteringPointRestoredDisruption.startTime | date: 'HH:mm, d MMMM yyyy') }} 
    </ng-container>
  </app-system-message>
</div>
